module.exports = __webpack_public_path__ + "static/media/Logo sgk-02.28aa7df3.png";